module.exports = __webpack_public_path__ + "static/whatsapp-7061f03da913f8e67de35b2d66ce45b2.png";